import { I18nComponente } from "@/types/gerais"

export const MEventoPeriodoi18n: I18nComponente = {
  "pt-BR": {
    inicioPlanejado: "início planejado",
    fimPlanejado: "fim planejado",
    atividadeRecorrente: "atividade recorrente",
    atividadeEmCurso: "(atividade em curso)",
    inicio: "início",
    fim: "fim"
  },
  "es-CO": {
    atividadeRecorrente: "actividad recurrente",
    atividadeEmCurso: "(actividad en curso)",
    inicioPlanejado: "inicio planeado",
    fimPlanejado: "fin planeado",
    inicio: "inicio",
    fim: "fin"
  }
}
